import React from 'react';

function NewPostTags({ name, isSelected, toggleTag }) {
    return (
        <button 
            type="button"
            className={`tag ${isSelected ? 'selected' : ''}`}
            onClick={() => toggleTag(name)}
        >
            {name}
        </button>
    );
}

export default NewPostTags;